module.exports = __webpack_public_path__ + "assets/01c3e0bea31cebfd5025a20e7a1f1116.png";